import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const KeygeekY1X = () => (
  <ArticleWrapper articleId="keygeek_y1x">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Keygeek Y1X</h1>
      {/* Add your Keygeek Y1X article content here */}
      <p>This is a placeholder article for the Keygeek Y1X switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default KeygeekY1X;
